const BUSINESS_TYPES = [
  {
    label: "Põllumajandustarnija / Maatilakauppa",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Loomade varjupaik / Hyväntekeväisyys",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Veiselihatootja",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Ettevõtetoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Piimatootmine",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Loomaarstitava",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Nõutud",
    },
  },
  salutation: {
    label: "Pöördumisviis",
    placeholder: "Valige pöördumisviis",
    errors: {
      required: "Pöördumisviis on nõutud",
      invalid: "Valige kehtiv pöördumisviis",
    },
  },
  firstName: {
    label: "Eesnimi",
    placeholder: "Jaan",
    errors: {
      authenticatedNameUpdateTrial:
        "Olete sisse loginud ja teie nime ei saa muuta.",
      required: "Eesnimi on nõutud",
      minLength: "Eesnimi peab olema vähemalt 2 tähemärki",
      maxLength: "Eesnimi võib olla kuni 50 tähemärki",
    },
  },
  lastName: {
    label: "Perekonnanimi",
    placeholder: "Tamm",
    errors: {
      authenticatedNameUpdateTrial:
        "Olete sisse loginud ja teie nime ei saa muuta.",
      required: "Perekonnanimi on nõutud",
      minLength: "Perekonnanimi peab olema vähemalt 2 tähemärki",
      maxLength: "Perekonnanimi võib olla kuni 50 tähemärki",
    },
  },
  email: {
    label: "E-post",
    placeholder: "jaan.tamm@naitis.ee",
    description:
      "Palun sisestage isiklik e-posti aadress, mitte jagatud e-posti aadress.",
    prefixWarningTitle: "Tuvastatud jagatud postkast",
    prefixWarningDescription:
      "Soovitame kasutada isiklikku e-posti aadressi parema kasutuskogemuse saamiseks",
    errors: {
      authenticatedEmailUpdateTrial:
        "Olete sisse loginud ja teie e-posti aadressi ei saa muuta.",
      required: "E-post on nõutud",
      invalidEmail: "Palun sisestage kehtiv e-posti aadress",
      emailAssociatedWithYourAccount:
        "Teie e-posti aadress on seotud teie kontoga ja seda ei saa muuta.",
    },
  },
  confirmEmail: {
    label: "Kinnita e-post",
    placeholder: "jaan.tamm@naitis.ee",
    errors: {
      authenticatedEmailUpdateTrial:
        "Olete sisse loginud ja teie e-posti aadressi ei saa muuta.",
      required: "E-posti kinnitus on nõutud",
      invalidEmail: "Palun sisestage kehtiv e-posti aadress",
      emailMatchError: "E-posti aadressid ei kattu",
    },
  },
  password: {
    label: "Parool",
    placeholder: "Sisestage oma parool",
    errors: {
      required: "Parool on nõutud",
    },
  },
  confirmPassword: {
    label: "Kinnita parool",
    placeholder: "Kinnitage oma parool",
    errors: {
      required: "Parooli kinnitus on nõutud",
      passwordMatchError: "Paroolid ei kattu",
    },
  },
  addressLine1: {
    label: "Aadressirida 1",
    placeholder: "Telliskivi 123",
    errors: {
      required: "Aadressirida 1 on nõutud",
      minLength: "Aadressirida 1 peab olema vähemalt 5 tähemärki",
      maxLength: "Aadressirida 1 võib olla kuni 100 tähemärki",
    },
  },
  addressLine2: {
    label: "Aadressirida 2",
    placeholder: "Korter 4B",
    errors: {
      required: "Aadressirida 2 on nõutud",
      maxLength: "Aadressirida 2 võib olla kuni 100 tähemärki",
    },
  },
  city: {
    label: "Linn",
    placeholder: "Tallinn",
    errors: {
      required: "Linn on nõutud",
      minLength: "Linn peab olema vähemalt 2 tähemärki",
      maxLength: "Linn võib olla kuni 50 tähemärki",
    },
  },
  country: {
    label: "Riik",
    placeholder: "Valige riik",
    errors: {
      required: "Riik on kohustuslik",
      invalid: "Palun valige kehtiv riik",
    },
  },
  state: {
    label: "Maakond",
    placeholder: "Valige maakond",
    errors: {
      required: "Maakond on nõutud",
      invalid: "Valige kehtiv maakond",
    },
  },
  jurisdiction: {
    label: "Litsentsi jurisdiktsioon",
    placeholder: "Valige litsentsi jurisdiktsioon",
    errors: {
      required: "Litsentsi jurisdiktsioon on nõutud",
      invalid: "Valige kehtiv jurisdiktsioon",
    },
  },
  zipCode: {
    label: "Postiindeks",
    placeholder: "10001",
    errors: {
      required: "Postiindeks on nõutud",
      invalid: "Palun sisestage kehtiv postiindeks",
    },
  },
  role: {
    label: "Roll",
    placeholder: "Valige oma roll",
    errors: {
      required: "Palun valige oma roll",
      invalid: "Valige kehtiv roll",
    },
  },
  businessType: {
    label: "Ettevõtte tüüp",
    placeholder: "Valige ettevõtte tüüp",
    errors: {
      required: "Ettevõtte tüüp on nõutud",
      invalid: "Valige kehtiv ettevõtte tüüp",
    },
  },
  businessName: {
    label: "Ettevõtte nimi",
    placeholder: "Sisestage ettevõtte nimi",
    errors: {
      required: "Ettevõtte nimi on nõutud",
      minLength: "Ettevõtte nimi peab olema vähemalt 2 tähemärki",
      maxLength: "Ettevõtte nimi võib olla kuni 100 tähemärki",
    },
  },
  businessSearch: {
    label: "Ettevõtte otsing:",
    addNewAccount: "Lisa uus ettevõtte konto",
    canNotFindBusiness: "Ei leia oma ettevõtet?",
    guideline:
      "Palun sisestage oma postiindeks ja seejärel valige allpool loendist.",
    guidelineForNameSearch:
      "Palun sisestage ettevõtte täisnimi ja seejärel valige loendist.",
    placeholder: "Kus te töötate?",
    noResults: "Tulemusi ei leitud",
    searching: "Otsimine...",
    selectedBusinessHeading: "Valitud ettevõte:",
    selectedBusinessNotCorrect: "Ei ole õige?",
    selectedBusinessTryAgain: "Proovi uuesti",
    selectedBusinessDismiss: "Tühista ettevõte",
    resultsFound: {
      singular: "1 ettevõte leitud",
      plural: "Mitu ettevõtet leitud",
    },
    errors: {
      network:
        "Ettevõtte otsingu teenusega ühenduse loomine ebaõnnestus. Palun proovige hiljem uuesti.",
    },
  },
  explicitConsent: {
    label:
      "Selle kasti märkides nõustun Elanco kasutustingimustega ja kinnitan, et Elanco kogub ja töötleb mu isikuandmeid vastavalt Elanco privaatsuspoliitikale",
    errors: {
      required: "E-posti nõusolek on nõutud",
    },
  },
  explicitSmsConsent: {
    label:
      "Selle ruudu märkimisega nõustun saama Elancolt turundusteateid SMS-i/tekstsõnumi teel.",
    errors: {
      required: "SMS-i nõusolek on kohustuslik",
    },
  },
  telephone: {
    label: "Isiklik telefon",
    placeholder: "Sisestage oma isiklik telefoninumber",
    dialCodeLabel: "Kood",
    dialCodePlaceholder: "Otsi riiki…",
    errors: {
      invalid: "Palun sisestage kehtiv telefoninumber.",
    },
  },
  businessTelephone: {
    label: "Ettevõtte telefon",
    placeholder: "Sisestage ettevõtte telefoninumber",
    dialCodeLabel: "Kood",
    dialCodePlaceholder: "Otsi riiki…",
    errors: {
      invalid: "Palun sisestage kehtiv telefoninumber.",
    },
  },
  professionalNumber: {
    label: "Kutsenumber",
    placeholder: "1234567",
    errors: {
      required: "Palun sisestage kutsenumber",
      maxLength: "Sisend ületab märkide piiri",
    },
  },
  addressSearch: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  businessSearchField: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  checkbox: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  checkboxGroup: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  combobox: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  datePicker: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  dateRange: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  dateTime: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  emailField: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  fileInput: {
    errors: {
      required: "Palun valige fail",
    },
  },
  number: {
    errors: {
      required: "Palun sisestage number",
      minValue: "Palun sisestage väärtus, mis on suurem kui miinimumväärtus",
      maxValue: "Palun sisestage väärtus, mis on väiksem kui maksimumväärtus",
    },
  },
  passwordField: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  rangeSlider: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  select: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  telephoneField: {
    errors: {
      required: "Palun sisestage ainult numbreid",
      invalidTelephone: "Palun sisestage kehtiv telefoninumber",
      invalidFormat: "Vigane numbrivorming",
    },
  },
  text: {
    errors: {
      required:
        "Palun kasutage ainult tähti (A-Z), numbreid (0-9) ja mitte sümboleid",
      maxLength: "Sisend ületab märkide piiri",
      minLength: "Sisend peab olema vähemalt 2 tähemärki",
    },
  },
  textarea: {
    characters: "tähemärki",
  },
  time: {
    errors: {
      required: "See väli on nõutud",
    },
  },
  form: {
    errors: {
      generic: "Vormi esitamisel ilmnes tõrge. Palun proovige uuesti.",
      reportAnIssue: "Palun teatage probleemist.",
      configuration: "Konfiguratsiooni viga",
      noFormQuestionsAvailable: "Vormi küsimused ei ole saadaval.",
      formComponentLoad:
        "Vormi komponenti ei saanud laadida toetamata välja tõttu.",
      code: "Kood",
      type: "Tüüp",
      missingRequiredFields:
        "Vormist puuduvad kohustuslikud väljad (E-post ja/või Nõusolek). Palun võtke ühendust administraatoriga vormi seadete parandamiseks.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Loomaarst",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Veiselihatootja",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apteeker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Tootja - segatud/muu",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Jaemüüja",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Lambakasvataja",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Loomaarst",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Loomaarst", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Loomaarst, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Loomaarstavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Loomaarstitava - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Loomaarstitava - Loomaarst",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Loomaarstitava - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Loomaarstasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Loomaarst",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Härra",
    value: "M.",
    id: "m",
  },
  {
    label: "Preili",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Härra",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Proua",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Proua/Preili",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
